<template>
  <div class="head">
    <div>
      <img class="headImg" src="../assets/images/banner.png" alt="11" />
    </div>
    <div class="logo">
      <div>
        <img class="logoImg" src="../assets/images/logo.png" />
      </div>
      <ul class="nav">
        <li @click="addstyle(1)" :class="{ active: add == 1 }">
          <router-link to="/home">首页</router-link>
        </li>
        <li @click="addstyle(2)" :class="{ active: add == 2 }">
          <router-link to="/service">产品服务</router-link>
        </li>
        <li @click="addstyle(3)" :class="{ active: add == 3 }">
          <router-link to="/case">成功案例</router-link>
        </li>
        <li @click="addstyle(4)" :class="{ active: add == 4 }">
          <router-link to="/contact">联系我们</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      add: 1,
    };
  },
  methods: {
    addstyle(value) {
      this.add = value;
    },
  },
};
</script>

<style lang='less' scoped>
.head {
  position: relative;
  width: 100%;
  height: 48.6875rem;
  background-color: aquamarine;
  .headImg {
    width: 100%;
    height: 48.6875rem;
  }
  .logo {
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 0;
    width: 100%;
    height: 9.8125rem;
    line-height: 9.8125rem;

    .logoImg {
      margin-left: 15rem;
      width: 7.0625rem;
      height: 5.8125rem;
      background: rgba(0, 0, 0, 0);
      opacity: 1;
    }
    .nav {
      margin-right: 15rem;

      li {
        float: left;
        width: 8.375rem;
        text-align: center;
        font-size: 1.375rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        opacity: 1;

        a:hover {
          color: #1e7fb2;
          border-bottom: #1e7fb2 2px solid;
          padding-bottom: 0.8125rem;
          border-radius: 1px;
        }
      }
      .active {
        a {
          color: #1e7fb2;
          border-bottom: #1e7fb2 2px solid;
          padding-bottom: 0.8125rem;
          border-radius: 1px;
        }
      }
    }
  }
}
</style>